<template>
	<div class="user-management-container">
		<tabel-panel  ref="tabel" :rowTemplate="rowTemplate" api="infoCompany" 
			:condition="conditionData" editType="pop" 
			@popConfirmButtonClick="popConfirmButtonClick"
			:autoSearch="true" :clickRowSelected="false">
			<template v-slot:tabelTitleRight >
				<add-button @buttonClick="add">新增</add-button>
			</template>
			<template v-slot:tabelTitleLeft >
				<div>公司信息</div>
			</template>
			<template v-slot:condition >
				<text-field v-model:value="conditionData.compnayName" labelText="名称：" class="condition-container-input">
				</text-field>
			</template>
			
			<template v-slot:oprator="$opData">
				<div class="opration">
					<del-button :useConfirm="true" 
						comfirmOkText="确定" 
						class="item" comfirmMessage="确定删除吗？" 
						@buttonClick="delSingleCompant($opData.data)"></del-button>
				</div>
			</template>
			
		</tabel-panel>
	</div>
</template>

<script>
	import textField from "@/components/textField.vue"
	import delButton from "@/components/delButton.vue"
	import addButton from "@/components/addButton.vue"
	import tabelPanel from "@/components/tabelPanel.vue"
	import popDialog from "@/components/popDialog.vue"
	import tableApi from "@/api/tabel.js"
	import {
			addCompany,
			DelCompany
		} from "@/api/index.js"
	import {
		errMsg,
		successMsg
	} from "@/notify/index.js"
	export default {
		name: "companyInfo",
		components: {
			tabelPanel,
			textField,
			delButton,
			addButton,
			popDialog
		},
		data() {
			const selectValueFn = (v, item) => {
				if (item) {
					return item.id
				}
			}
			
			const selectRemoteSearchData = async () => {
			
				let source = await tableApi.ParentCompName();
				if (source.code == 0) {
					let data = source.data.list.map(({
						id,
						CompName
					}) => {
						return {
							label: CompName,
							value: id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg( source.message)
				}
			}


			const checkboxData= (v, item) => {
				if (item) {
					return item.id
				}
			}
			//货运公司
			const checkboxDataComp = async () => {
				let source = await tableApi.TransComp();
				if (source.code == 0) {
					let data = source.data.list.map(({
						id,
						Name
					}) => {
						return {
							label: Name,
							value: id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg(this, source.message)
				}
			}
			return {
				popDataObj: [{
						label: "申通",
						value: 0
				}],
				queryShow: false,
				rowTemplate: [
					{
						headerLabel: "公司编号",
						dataIndex: 'id',
						width: 75,
						showInList: true,
						showInDetail: true,
						editType: 'text',
						rules:[{
							required: true,
							message: '请输入用户名', 
						}],
						renderToHtml: true
					},{
						headerLabel: '公司名称',
						width: 135,
						editable: true,
						readOnly: true,
						dataIndex: 'CompName',
						rules:[{
							required: true,
							message: '请输入公司'
						}],
					},{
						headerLabel: '简称',
						editable: true,
						dataIndex: 'ShortName'
					},{
						headerLabel: '英文名称',
						editable: true,
						showInList: false,
						dataIndex: 'EnCompName'
					},{
						headerLabel: '上级公司',
						width: 135,
						editable: false,
						editType: "text",
						dataIndex: 'ParentCompName',
					},{
						headerLabel: '上级公司',
						editable: true,
						showInList: false,
						editType: "select",
						dataIndex: 'ParentId',
						selectRemoteSearchData,
						selectValueFn
					},{
						headerLabel: '联系人',
						editable: true,
						dataIndex: 'LinkMan'
					},{
						headerLabel: '电话',
						editable: true,
						dataIndex: 'TelNo'
					},{
						headerLabel: '手机',
						editable: true,
						dataIndex: 'TelNo'
					},{
						headerLabel: '传真',
						editable: true,
						showInList: false,
						dataIndex: 'FaxNo'
					},{
						headerLabel: 'Email',
						editable: true,
						showInList: false,
						dataIndex: 'Email'
					},{
						headerLabel: '邮编',
						editable: true,
						showInList: false,
						dataIndex: 'PostNo'
					},{
						headerLabel: '地址',
						width: 145,
						editable: true,
						editType: "textarea",
						dataIndex: "Address",
						rows: 2
					},{
						headerLabel: '英文地址',
						editable: true,
						showInList: false,
						editType: "textarea",
						dataIndex: "EnAddress",
						rows: 2
					},{
						width: 60,
						headerLabel: '客户',
						editable: true,
						dataIndex: 'TypeCustomer',
						editType: 'checkbox',
						dataRender: ( v ) => {
							if (v == true) {
								return "是"
							} else if(v == false){
								return "否"
							} else {
								return v
							}
						},
						fieldData: [ {
								label: "",
								value: true
						}]
					},{
						width: 60,
						headerLabel: '休恩公司',
						editable: true,
						dataIndex: 'TypeShooin',
						editType: 'checkbox',
						dataRender: ( v ) => {
							if (v == true) {
								return "是"
							} else if(v == false){
								return "否"
							} else {
								return v
							}
						},
						fieldData: [ {
								label: "",
								value: true
						}]
					},{
						width: 60,
						headerLabel: '维修中心',
						editable: true,
						dataIndex: 'TypeService',
						editType: 'checkbox',
						dataRender: ( v ) => {
							if (v == true) {
								return "是"
							} else if(v == false){
								return "否"
							} else {
								return v
							}
						},
						fieldData: [ {
								label: "",
								value: true
						}]
					},{
						width: 60,
						headerLabel: '维修返回公司',
						editable: true,
						editType: "checkbox",
						showInList: false,
						dataIndex: 'TypeShooinReturn',
						fieldData: [{
								label: "",
								value: true
						}]
					},{
						headerLabel: '货运公司',
						editable: true,
						editType: "checkbox",
						showInList: false,
						dataIndex: 'App1',
						selectRemoteSearchData: checkboxDataComp,
						selectValueFn: checkboxData,
						fieldData: [],
						// fieldData: [{
						// 		label: "申通",
						// 		value: 0
						// 	}, {
						// 		label: "德邦",
						// 		value: 1
						// 	}, {
						// 		label: "中通",
						// 		value: 2
						// 	}, {
						// 		label: "司机送货",
						// 		value: 3
						// 	}, {
						// 		label: "联邦",
						// 		value: 4
						// 	}, {
						// 		label: "顺丰",
						// 		value: 5
						// 	}, {
						// 		label: "DHL",
						// 		value: 6
						// 	}, {
						// 		label: "速尔",
						// 		value: 74  
						// }]
					},{
						headerLabel: '收货公司',
						width: 60,
						dataIndex: 'TypeShooinReturn',
						dataRender: ( v ) => {
							if (v == true) {
								return "是"
							} else if(v == false){
								return "否"
							} else {
								return v
							}
						},
						
					},{
						headerLabel: '备注',
						editable: true,
						showInList: false,
						editType: "textarea",
						dataIndex: "Appendix",
						rows: 2
					},{
						headerLabel: '操作',
						slot:'oprator'
					}
				],
				conditionData: {
					compnayName: ''
				},
				checkboxData:[]
			}
		},
		mounted(){
			this.selectDataComp()
			console.log('checkboxData:',this.checkboxData)
			// console.log('rowTemplate:',this.rowTemplate)
			// console.log('rowTemplate18:',this.rowTemplate[18])
			// this.rowTemplate[18].fieldData = this.checkboxData
			// console.log('rowTemplate19:',this.rowTemplate[18])
			// dataIndex: 'App1',
			// fieldData: []
		},
		methods: {
			//货运公司
			async selectDataComp(){
				let source = await tableApi.TransComp();
				this.checkboxData = source.data.list
				console.log('checkboxData=:',this.checkboxData )
				if (source.code == 0) {
					let data = source.data.list.map(({
						id,
						Name
					}) => {
						return {
							label: Name,
							value: id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg(this, source.message)
				}
			},
			reloadData() {
				this.$refs.tabel.reloadData()
			},
			add() {
				this.$refs.tabel.showDialog(null, "新增")
				
			},
			//单列表删除
			delSingleCompant({
				row
			}) {
				let id = row.id
				DelCompany({id}).then(data => {
					if (data.code == 0) {
						successMsg(data.message)
						this.reloadData()
						this.$refs.tabel.closeDialog()
					} else {
						errMsg(data.message)
					}
				})
			},
			popConfirmButtonClick({
				slotData
			}) {
				console.log(slotData)
				console.log(typeof slotData.TypeShooin)
				if(slotData.App1 != null && typeof slotData.App1 != 'string'){
					slotData.App1 = slotData.App1.join()
				}
				slotData.TypeShooinReturn = typeof slotData.TypeShooinReturn == 'boolean' ? slotData.TypeShooinReturn : slotData.TypeShooinReturn[0]
				slotData.TypeShooin = typeof slotData.TypeShooin == 'boolean' ? slotData.TypeShooin : slotData.TypeShooin[0]
				slotData.TypeCustomer =  typeof slotData.TypeCustomer == 'boolean' ? slotData.TypeCustomer : slotData.TypeCustomer[0]
				slotData.TypeService =  typeof slotData.TypeService == 'boolean' ? slotData.TypeService : slotData.TypeService[0]

				if (slotData.id) {
					let powerObj = JSON.stringify(slotData) 
					addCompany({data: powerObj}).then(data => {
						if (data.code == 0) {
							successMsg(data.message)
							this.reloadData()
							this.$refs.tabel.closeDialog()
						} else {
							errMsg(data.message)
						}
					})
				} else {
					let powerObj = JSON.stringify(slotData) 
					addCompany({data: powerObj}).then(data => {
						if (data.code == 0) {
							successMsg(data.message)
							this.reloadData()
							this.$refs.tabel.closeDialog()
						} else {
							errMsg(data.message)
						}
					})
				}
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	@import "~@/assets/styles/_handle.scss";
	.user-management-container {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		overflow: hidden;
		align-items: center;
		align-content: center;
		@include background_color("user-management-bg-color");

		.search-button-icon{
			background: none;
		}
			
		.del {
			margin-left: 10px;
		}

		.condition-container-input {
			width: 270px;
		}

		.opration {
			height: 100%;
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			align-content: center;

			.item {
				&:nth-child(n+1) {
					margin-left: 10px;
				}
			}
		}

		::v-deep .text-field-container .text-field-container-input-container .checkbox-group .checkbox-group-item {
			margin-left: 10px;
		}
		
	}
	::v-deep .el-table--scrollable-x .el-table__body-wrapper {
		overflow: auto !important;
	}
	::v-deep .el-form--label-top .el-form-item__label {
		line-height: 26px;
		padding: 8px 0 2px 0;
	}
</style>
